/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import OwnerShow from "@/components/pages/admin/OwnerShow/index.vue";
import UserList from "@/components/pages/admin/UserList/index.vue";
import TerminalList from "@/components/pages/admin/TerminalList/index.vue";

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * 事業者管理
   ********************************************************************************************************************/

  // ユーザ管理
  {
    path: '/admin/user',
    name: '/admin/user/UserList',
    component: UserList,
    meta: {
      label: 'ユーザ管理',
      parent: 'Home',
      permissions: ['admin'],
    }
  },
  // 事業者管理
  {
    path: '/admin/owner',
    name: '/admin/owner/OwnerShow',
    component: OwnerShow,
    meta: {
      label: '事業者管理',
      parent: 'Home',
      permissions: ['admin'],
    }
  },
  // サイト管理
  {
    path: '/admin/terminal',
    name: '/admin/terminal/TerminalList',
    component: TerminalList,
    meta: {
      label: 'サイト管理',
      parent: 'Home',
      permissions: ['admin'],
    }
  },
];

export default routes;
